<template>
  <div>
    <el-card>
      <div class="carditem">
        <div class="title" v-for="item in reportList" :key="item.index">
          <i class="el-icon-caret-right"></i>
          <p @click="getdetails(item.year, item.quarter, item.title)">
            {{ item.year + "年" + item.quarter + item.title }}
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currPage: 1,
      totalSize: 10,
      reportList: [
        // { title: "2021年上半年质评上报表" },
        // { title: "2020年下半年质评上报表" },
        // { title: "2020年上半年质评上报表" },
        // { title: "2019年下半年质评上报表" },
      ],
    };
  },
  created() {
    this.getReportList();
  },
  methods: {
    async getReportList() {
      const { data: res } = await this.$http.post("quality/evaluate/list", {
        currPage: this.currPage,
        totalSize: this.totalSize,
        // title: "质评上报表",
        titleCode:'1'
      });
      if (res.code !== 200) {
        this.$message.error(res.message);
      } else {
        this.reportList = res.data.records;
      }
    },
    getdetails(year, quarter, title) {
      this.$router.push({
        path: "/userreportdetails",
        query: {
          year: year,
          quarter: quarter,
          title: title,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>